// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text[data-v-502ee4c9]{margin-bottom:16px}.base-lined-card[data-v-502ee4c9]{height:100%;display:flex;flex-direction:column;align-items:stretch}.base-lined-card[data-v-502ee4c9]  .title{margin-bottom:5px}.base-lined-card[data-v-502ee4c9]  .textual-content{flex-grow:1;display:flex;flex-direction:column;align-items:center}.btn[data-v-502ee4c9]{margin-top:auto;cursor:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
